import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import SolutionsPage from "@/pages/SolutionsPage";
import IndustriesPage from "@/pages/IndustriesPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import CaseStudies from "@/pages/CaseStudies";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Configurator from "@/pages/Configurator";
import AdminInbox from "@/pages/AdminInbox";
import CallbackPage from "@/pages/CallbackPage";
import WhyPage from "@/pages/WhyPage";
import CompareLightspeed from "@/pages/CompareLightspeed";
import Legal from "@/pages/Legal";
import Sitemap from "@/pages/Sitemap";
import { CityPage, ServiceAreaPage, AlternativePage, SeoSolutionPage } from "@/pages/SeoLanding";
import OffersList from "@/pages/OffersList";
import OfferDetail from "@/pages/OfferDetail";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminProtected from "@/admin/AdminProtected";
import AdminOffersList from "@/admin/AdminOffersList";
import AdminOfferEditor from "@/admin/AdminOfferEditor";
import AdminLeadsList from "@/admin/AdminLeadsList";
import AdminSettings from "@/admin/AdminSettings";
import AdminVouchersList from "@/admin/AdminVouchersList";
import AdminPages from "@/pages/AdminPages";
import CheckoutReturn from "@/pages/CheckoutReturn";

function ScrollToHash() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [hash, pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToHash />
      <AdminAuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why" element={<WhyPage />} />
          <Route path="/about" element={<Legal slug="about" />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/solutions/:slug" element={<SolutionsPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/payments" element={<IntegrationsPage />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/configurator" element={<Configurator />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/compare/lightspeed" element={<CompareLightspeed />} />
          <Route path="/alternatives/:slug" element={<AlternativePage />} />
          <Route path="/pos/:slug" element={<CityPage />} />
          <Route path="/service-areas/:slug" element={<ServiceAreaPage />} />
          <Route path="/waiter-app-pos" element={<SeoSolutionPage slug="waiter-app-pos" />} />
          <Route path="/foodtruck-pos" element={<SeoSolutionPage slug="foodtruck-pos" />} />
          <Route path="/taptopay-terminals" element={<SeoSolutionPage slug="taptopay-terminals" />} />
          <Route path="/local-support-pos" element={<SeoSolutionPage slug="local-support-pos" />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/offers" element={<OffersList />} />
          <Route path="/offers/fr/:slug" element={<OfferDetail localeOverride="fr" />} />
          <Route path="/offers/de/:slug" element={<OfferDetail localeOverride="de" />} />
          <Route path="/offers/:slug" element={<OfferDetail />} />
          <Route path="/checkout/return" element={<CheckoutReturn />} />
          <Route path="/admin" element={<Outlet />}>
            <Route index element={<AdminInbox />} />
            <Route path="login" element={<AdminLogin />} />
            <Route path="offers" element={<AdminProtected><AdminOffersList /></AdminProtected>} />
            <Route path="offers/:id" element={<AdminProtected><AdminOfferEditor /></AdminProtected>} />
            <Route path="pages" element={<AdminProtected><AdminPages /></AdminProtected>} />
            <Route path="leads" element={<AdminProtected><AdminLeadsList /></AdminProtected>} />
            <Route path="vouchers" element={<AdminProtected><AdminVouchersList /></AdminProtected>} />
            <Route path="settings" element={<AdminProtected><AdminSettings /></AdminProtected>} />
          </Route>
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}
